import type { BlackFridayCampaignConfig } from "@/lib/campaigns/black-friday/config";

export type CampaignPhase = "upcoming" | "early-access" | "live" | "ended";

export function getCampaignPhase(now: Date, config: BlackFridayCampaignConfig): CampaignPhase {
	if (now < getBoundary(config.dates.earlyAccess, config)) return "upcoming";
	if (now < getBoundary(config.dates.publicStart, config)) return "early-access";
	if (now < getBoundary(config.dates.endExclusive, config)) return "live";
	return "ended";
}

export function getCountdownTarget(phase: CampaignPhase, config: BlackFridayCampaignConfig): Date | null {
	switch (phase) {
		case "upcoming":
			return getBoundary(config.dates.earlyAccess, config);
		case "early-access":
			return getBoundary(config.dates.publicStart, config);
		case "live":
			return getBoundary(config.dates.endExclusive, config);
		case "ended":
			return null;
	}
}

function getBoundary(date: string, config: BlackFridayCampaignConfig): Date {
	return new Date(`${date}T00:00:00${config.utcOffset}`);
}
